/** Backend code for the birth-date range criterion. */
const birthDateCriteriaCode = 'DatNarozeni';
/** Backend code for the age-in-months range criterion. */
const ageInMonthsCriteriaCode = 'MesiceOdNarozeni';
/** Backend code for the last-calving-date range criterion. */
const lastCalvingDateCriteriaCode = 'DatPoslOtel';
/** Backend code for the months-since-last-calving range criterion. */
const monthsSinceLastCalvingCriteriaCode = 'MesiceOdOteleni';

/** Semantic group used when explaining an automatic paired-criteria reset. */
export type PairedCriteriaGroup = 'age' | 'calving';

/** Mutually exclusive criteria grouped by the setting they represent. */
export const pairedCriteriaGroupByCode: Readonly<Record<string, PairedCriteriaGroup>> = {
    [birthDateCriteriaCode]: 'age',
    [ageInMonthsCriteriaCode]: 'age',
    [lastCalvingDateCriteriaCode]: 'calving',
    [monthsSinceLastCalvingCriteriaCode]: 'calving',
};

/** Number ranges participating in mutually exclusive date/number pairs. */
export const pairedNumberRangeCriteriaCodes: ReadonlyArray<string> = [
    ageInMonthsCriteriaCode,
    monthsSinceLastCalvingCriteriaCode,
];

/** Date ranges and their mutually exclusive number ranges. */
export const dateRangeToNumberRangeCriteriaCodes: Readonly<Record<string, string>> = {
    [birthDateCriteriaCode]: ageInMonthsCriteriaCode,
    [lastCalvingDateCriteriaCode]: monthsSinceLastCalvingCriteriaCode,
};

/** Number ranges and their mutually exclusive date ranges. */
export const numberRangeToDateRangeCriteriaCodes: Readonly<Record<string, string>> = {
    [ageInMonthsCriteriaCode]: birthDateCriteriaCode,
    [monthsSinceLastCalvingCriteriaCode]: lastCalvingDateCriteriaCode,
};

/** All criteria pairs indexed in both directions for UI interactions. */
export const pairedCriteriaCodes: Readonly<Record<string, string>> = {
    ...dateRangeToNumberRangeCriteriaCodes,
    ...numberRangeToDateRangeCriteriaCodes,
};
